// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

document.querySelectorAll(".buttonCon button").forEach(el => el.addEventListener('click', () => {

  document.querySelectorAll(".buttonCon button").forEach(el => el.classList.remove("selected") );
  el.classList.add('selected');

  var chosenID = el.dataset.id;

  document.querySelectorAll(".tableCon .table").forEach(el => el.classList.remove("selected") );
  document.querySelector(`[data-set=${chosenID}]`).classList.add('selected');
}))
